import axios from 'axios';

const RESOURCE_NAME = '/api/job';

export default {
	getAll() {
		return axios.get(RESOURCE_NAME);
	},

	getPaged(_pageSize, _pageNumber, _sortProp, _sortDir) {
		return axios.get(`${RESOURCE_NAME}?pageSize=${_pageSize}&pageNumber=${_pageNumber}&sortProp=${_sortProp}&sortDir=${_sortDir}`);
	},

	get(id) {
		return axios.get(`${RESOURCE_NAME}/${id}`);
	},

	search(query) {
		return axios.get(`${RESOURCE_NAME}?${query}`);
	},

	getEnum(value) {
		return axios.get(`${RESOURCE_NAME}/${value}`);
	},

	create(data) {
		return axios.post(RESOURCE_NAME, data);
	},

	update(id, data) {
		return axios.put(`${RESOURCE_NAME}/${id}`, data);
	},

	delete(id) {
        return axios.delete(`${RESOURCE_NAME}/${id}`);
    },


    createAssignments(id, data) {
		return axios.post(`${RESOURCE_NAME}/${id}/assignment`, data);
    },
    
	updateAssignments(id, data) {
		return axios.put(`${RESOURCE_NAME}/${id}/assignment`, data);
	},

	getStates() {
		return axios.get('/api/jobstatus');
	},
};


// WEBPACK FOOTER //
// ./src/api-services/job.service.js